import { axiosClient } from "./axiosClient";
import { auth, googleAuthProvider, twitterAuthProvider} from '../Firebase'
import { signInWithPopup, getAdditionalUserInfo } from "firebase/auth";
import { socialLogInAPI } from "./api";

export const setJWTHeader = (isLogout=false) => {
    axiosClient.setHeader("Authorization", isLogout? "" : localStorage.getItem("access_token") !);
}

export const setUserInfo = (userData:any) => {
  const useInfo ={
    photoURL:userData.user.photoURL, name:userData.user.displayName, email:userData.user.email
  }
  localStorage.setItem('user_info', JSON.stringify(useInfo))
}

export const socialSignIn = async (socialMedia: string) => {
    try {
      const result = await signInWithPopup(auth, socialMedia === 'google' ? googleAuthProvider : twitterAuthProvider);
      const info = getAdditionalUserInfo(result);
  
      const bodyData = {
        email: info?.profile?.email || '',
        email_verified: info?.profile?.email_verified || true,
        source_id: info?.providerId || '',
        id_token: result?.user ? await result.user.getIdToken() : '',
      };
        
      const response:any = await socialLogInAPI(bodyData);
      const data: { [key: string]: string } = response.data.data;
      localStorage.setItem('access_token', data.access_token);
      setUserInfo(result);
      setJWTHeader();
      return data;
    } catch (error) {
      return error; 
    }
}